import React, { useEffect, useRef } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  useMap,
  Tooltip,
  Popup,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "../../css/ExternalLiveLocation.css";
import L from "leaflet";

const MapRecenter = ({ lat, lng }) => {
  const map = useMap();
  const hasInitializedRef = useRef(false);
  useEffect(() => {
    if (lat && lng) {
      if(hasInitializedRef.current){
        map.setView([lat, lng], 12);
        hasInitializedRef.current= true;
      }
      else{
        map.panTo([lat, lng]);
      }
    }
  }, [lat, lng, map]);
  return null;
};

const createVehicleIcon = (heading = 0) => {
  const color = "#7764ba";
  const size = 30;

  return L.divIcon({
    html: `
      <div style="transform: rotate(${heading}deg); width: ${size}px; height: ${size}px; display: flex; align-items: center; justify-content: center; transition: transform 0.1s linear; filter: drop-shadow(0px 2px 2px rgba(0,0,0,0.4));">
        <svg width="${size}" height="${size}" viewBox="0 0 100 100" style="display: block;">
            <path d="M50 0 L 100 100 L 50 75 L 0 100 Z" fill="${color}"/>
        </svg>
      </div>
    `,
    className: "custom-arrow-marker",
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2],
  });
};

const createJobIcon = (label) => {
  return L.divIcon({
    html: `
      <div style="position: relative; width: 40px; height: 40px; display: flex; justify-content: center;">
        <img src="https://cdn-icons-png.flaticon.com/512/252/252025.png" style="width: 40px; height: 40px; position: absolute; top: 0; left: 0;" />
        <div style="position: absolute; top: 5px; width: 20px; height: 20px; background-color: #7764ba; border-radius: 50%; display: flex; align-items: center; justify-content: center;">
          <span style="color: #ffffff; font-weight: bold; font-size: 10px; font-family: Arial, sans-serif; line-height: 1;">${label}</span>
        </div>
      </div>
    `,
    className: "custom-job-marker",
    iconSize: [40, 40],
    iconAnchor: [20, 40],
  });
};

const MapOSView = ({ vehicleLocation, jobLocations }) => {
  const defaultCenter = [6.9271, 79.8612];
  let viaCounter = 0;

  return (
    <div className="map-view-container">
      <MapContainer
        center={defaultCenter}
        zoom={9}
        zoomControl={false}
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer
          attribution="Google Maps"
          url="https://www.google.cn/maps/vt?lyrs=m@189&gl=cn&x={x}&y={y}&z={z}"
        />

        {vehicleLocation?.lat && vehicleLocation?.lng && (
          <MapRecenter lat={vehicleLocation.lat} lng={vehicleLocation.lng} />
        )}

        {vehicleLocation?.lat && vehicleLocation?.lng && (
          <Marker
            position={[vehicleLocation.lat, vehicleLocation.lng]}
            icon={createVehicleIcon(vehicleLocation.heading)}
          />
        )}

        {jobLocations.map((loc, index) => {
          if (!loc.latitude || !loc.longitude) return null;

          let label = "V";
          if (loc.type === "start") {
            label = "S";
          } else if (loc.type === "end") {
            label = "E";
          } else if (loc.type === "via") {
            viaCounter++;
            label = `V${viaCounter}`;
          }

          return (
            <Marker
              key={`${loc.name}-${index}`}
              position={[loc.latitude, loc.longitude]}
              icon={createJobIcon(label)}
            >
              <Tooltip direction="bottom">{loc.name}</Tooltip>

              <Popup minWidth={260} maxWidth={340}>
                <div
                  style={{
                    fontFamily:
                      "'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    boxSizing: "border-box",
                    padding: "12px 28px 8px 18px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      fontWeight: "700",
                      fontSize: "13px",
                      color: "#212121",
                      marginBottom: "12px",
                      lineHeight: "1.5",
                      wordBreak: "break-word",
                      width: "100%",
                      textAlign: "center",
                    }}
                  >
                    {loc.name}
                  </div>

                  <div
                    style={{
                      fontSize: "10px",
                      color: "#757575",
                      textTransform: "uppercase",
                      letterSpacing: "0.8px",
                      marginBottom: "4px",
                      fontWeight: "600",
                      width: "100%",
                      textAlign: "center",
                    }}
                  >
                    Arrival ETA
                  </div>

                  <div
                    style={{
                      color: "#7764ba",
                      fontWeight: "600",
                      fontSize: "13px",
                      lineHeight: "1.4",
                      whiteSpace: "nowrap",
                      width: "100%",
                      textAlign: "center",
                    }}
                  >
                    {loc.arrivalEta
                      ? new Date(loc.arrivalEta).toLocaleString()
                      : "N/A"}
                  </div>
                </div>
              </Popup>
            </Marker>
          );
        })}
      </MapContainer>
    </div>
  );
};

export default MapOSView;
